import React, { Component } from 'react';
import {HashRouter, Route, Switch} from 'react-router-dom';
import {RegisterPage, DownloadAppPage, AcceptedPage, Invitation404Page, InvitationPage} from './components/pages';

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact path='/register' component={RegisterPage} />
          <Route exact path='/download' component={DownloadAppPage} />
          <Route exact path='/accepted' component={AcceptedPage} />
          <Route exact path='/404' component={Invitation404Page} />
          <Route exact path='/invitation/:uuid/:language' component={InvitationPage} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
